import Box from '@mui/material/Box';

const PageLabel = ({ label = '' }) => {
  return (
    <Box component="h3" sx={{ textAlign: 'center' }}>
      {label}
    </Box>
  );
};
export default PageLabel;
